import { Component, EventEmitter, Input, Output, OnInit, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Client } from 'core/models/client';
import { environment } from 'environments/environment';
import { SsoConfigurationsService } from '../services/sso-configurations.service';

@Component({
  selector: 'lms-client-sso',
  templateUrl: './client-sso.component.html',
  styleUrls: ['./client-sso.component.scss'],
  providers: [SsoConfigurationsService]
})
export class ClientSsoComponent implements OnInit, OnChanges {
  @Input() client: Client;
  @Output() saved = new EventEmitter<Client>();
  public ssoConfigMap: any = {}; //Map<string, any>;
  public sids: any = environment['sids'];

  constructor(public ssoConfigurationsService: SsoConfigurationsService, public route: ActivatedRoute) {}

  ngOnInit() {}

  ngOnChanges() {
    this.fetchClientSsoConfigurations();
  }

  fetchClientSsoConfigurations() {
    if (this.client) {
      this.ssoConfigurationsService.fetchClientSsoConfigurations(this.client.id).then((data) => {
        const newConfigMap = {};
        data.forEach((ssoConfig) => (newConfigMap[ssoConfig.sid] = ssoConfig));
        this.ssoConfigMap = newConfigMap;
      });
    }
  }

  onSaved(ssoConfig: any): void {
    this.ssoConfigMap[ssoConfig.sid] = ssoConfig;
    this.saved.emit(ssoConfig);
  }
}
